import { WordBatchStatus, CardLearningStatus } from './words';

export enum UserRole {
  User = 'user',
  Admin = 'admin'
}

export enum UserStatus {
  Active = 'active',
  Suspended = 'suspended',
  Deleted = 'deleted',
  Pending = 'pending'
}

export enum MediaType {
  MOVIE   = 'movie',
  TVSHOW  = 'tvshow',
  EPISODE = 'episode'
}

export enum DataStatus {
  Pending = 'pending',
  Processing = 'processing',
  Partial = 'partial',
  Ready = 'ready',
  Deleted = 'deleted',
  Error = 'error'
}

export interface AutocompleteEpisode {
  num: number;
  title: string;
  dbId?: string;
  opsubsId?: number;
  imdbId?: number;
}

export interface AutocompleteSeason {
  num: number;
  episodes: AutocompleteEpisode[];
}

export interface AutocompleteItem {
  title: string;
  originalTitle: string;
  year: string;
  poster?: string;
  dbId?: string;
  opsubsId?: string;
  imdbId?: number;
  tmdbId?: number;
  type: 'movie' | 'tvshow';
  seasons?: AutocompleteSeason[];
}

export interface RequestWordsParams {
  show: AutocompleteItem;
  season?: number;
  episode?: number;
  part?: number;
}

export interface RequestYoutubeWordsParams {
  youtubeUrl?: string;
  screenmediaId?: string;
  part?: number;
}

export interface ShortMediaInfo {
  title: string;
  subtitle?: string;
  year?: number;
  poster?: string;
  tag?: string;
}

export interface RequestCollectionWordsParams {
  collectionId?: string;
  part?: number;
  shift?: number;
}

export interface RequestCollectionWordDeleteParams {
  collectionId?: string;
  savedWordId?: string;
}

export interface LastWatchedDetails {
  currentCardIndex?: number;
  cardStatuses?: Record<string, CardLearningStatus | null> | null;
  loadedCardsTotal?: number;
  activeCardsLimit?: number;
}

export interface LastWatched {
  show: AutocompleteItem;
  screenmediaId?: string;
  season?: number;
  episode?: number;
  details?: LastWatchedDetails;
}

export interface LastWatchedExt extends LastWatched {
  id: string;
  updatedAt: Date;
  lastUsedAt: Date;
  dataStatus: DataStatus;
  wordbatches: { part: number; status: WordBatchStatus }[];
  details?: LastWatchedDetails;
}

export interface LastWatchedResponse {
  list: LastWatchedExt[];
  error?: string;
}

export interface EpisodeProgressResponse {
  total: number;
  remembered: number;
  notRemembered: number;
  completionPercent: number;
}

export interface StoredUser {
  id: string;
  email?: string | null;
  tgid?: string | number | null;
  // lastWatched?: LastWatchedResponse;
  role: UserRole,
  status: UserStatus,
  avatar?: string | null;
}
